/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { calculateFormula } from '../fn/tag-computed/calculate-formula';
import { CalculateFormula$Params } from '../fn/tag-computed/calculate-formula';
import { createTagComputed } from '../fn/tag-computed/create-tag-computed';
import { CreateTagComputed$Params } from '../fn/tag-computed/create-tag-computed';
import { getTagComputed } from '../fn/tag-computed/get-tag-computed';
import { GetTagComputed$Params } from '../fn/tag-computed/get-tag-computed';
import { TagComputedConfigInfos } from '../models/tag-computed-config-infos';
import { TagComputedFormulaCalculateResult } from '../models/tag-computed-formula-calculate-result';
import { TagComputedFormulaValidateResult } from '../models/tag-computed-formula-validate-result';
import { updateTagComputed } from '../fn/tag-computed/update-tag-computed';
import { UpdateTagComputed$Params } from '../fn/tag-computed/update-tag-computed';
import { validateFormula } from '../fn/tag-computed/validate-formula';
import { ValidateFormula$Params } from '../fn/tag-computed/validate-formula';


/**
 * All about tag computed
 */
@Injectable({ providedIn: 'root' })
export class TagComputedService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createTagComputed()` */
  static readonly CreateTagComputedPath = '/tags-computed';

  /**
   * Create a new Computed tags.
   *
   * Create a new Computed tags
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTagComputed()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTagComputed$Response(params: CreateTagComputed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createTagComputed(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new Computed tags.
   *
   * Create a new Computed tags
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTagComputed$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTagComputed(params: CreateTagComputed$Params, context?: HttpContext): Observable<void> {
    return this.createTagComputed$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTagComputed()` */
  static readonly GetTagComputedPath = '/tags-computed/{uid}';

  /**
   * Retrieve a computed tags configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTagComputed()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTagComputed$Response(params: GetTagComputed$Params, context?: HttpContext): Observable<StrictHttpResponse<TagComputedConfigInfos>> {
    return getTagComputed(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a computed tags configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTagComputed$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTagComputed(params: GetTagComputed$Params, context?: HttpContext): Observable<TagComputedConfigInfos> {
    return this.getTagComputed$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagComputedConfigInfos>): TagComputedConfigInfos => r.body)
    );
  }

  /** Path part for operation `updateTagComputed()` */
  static readonly UpdateTagComputedPath = '/tags-computed/{uid}';

  /**
   * Update an existing Computed tags.
   *
   * Update an existing Computed tags
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTagComputed()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTagComputed$Response(params: UpdateTagComputed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateTagComputed(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an existing Computed tags.
   *
   * Update an existing Computed tags
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTagComputed$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTagComputed(params: UpdateTagComputed$Params, context?: HttpContext): Observable<void> {
    return this.updateTagComputed$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `validateFormula()` */
  static readonly ValidateFormulaPath = '/tags-computed/validate';

  /**
   * Validate a formula and returns the resulting type of this formula.
   *
   * Validate a formula and returns the resulting type of this formula
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateFormula()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validateFormula$Response(params: ValidateFormula$Params, context?: HttpContext): Observable<StrictHttpResponse<TagComputedFormulaValidateResult>> {
    return validateFormula(this.http, this.rootUrl, params, context);
  }

  /**
   * Validate a formula and returns the resulting type of this formula.
   *
   * Validate a formula and returns the resulting type of this formula
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validateFormula$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validateFormula(params: ValidateFormula$Params, context?: HttpContext): Observable<TagComputedFormulaValidateResult> {
    return this.validateFormula$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagComputedFormulaValidateResult>): TagComputedFormulaValidateResult => r.body)
    );
  }

  /** Path part for operation `calculateFormula()` */
  static readonly CalculateFormulaPath = '/tags-computed/calculate';

  /**
   * Calculate a formula with current data.
   *
   * Calculate a formula with current data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculateFormula()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculateFormula$Response(params: CalculateFormula$Params, context?: HttpContext): Observable<StrictHttpResponse<TagComputedFormulaCalculateResult>> {
    return calculateFormula(this.http, this.rootUrl, params, context);
  }

  /**
   * Calculate a formula with current data.
   *
   * Calculate a formula with current data
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculateFormula$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculateFormula(params: CalculateFormula$Params, context?: HttpContext): Observable<TagComputedFormulaCalculateResult> {
    return this.calculateFormula$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagComputedFormulaCalculateResult>): TagComputedFormulaCalculateResult => r.body)
    );
  }

}
